import {Link} from "react-router-dom";
import {productImageFromUrl, type AccountOrder} from "@corporatesclub/shared";
import {useI18n} from "./I18nProvider";
import {MoneyDisplay} from "./MoneyDisplay";

export function OrderDetailView({order}: {order: AccountOrder}) {
  const {t} = useI18n();
  return (
    <div className="cc-account__detail">
      <section className="cc-account__sectionCard cc-account__orderHero">
        <div className="cc-account__orderHeroTop">
          <div className="cc-account__orderHeroId">
            <span className="cc-account__orderHeroLabel">{t("Order")}</span>
            <strong>#{order.displayNumber}</strong>
          </div>
          <span className={`cc-account__badge cc-account__badge--sts${order.status}`}>{order.statusLabel}</span>
        </div>
        <div className="cc-account__orderHeroMeta">
          <div className="cc-account__orderHeroStat">
            <span className="cc-account__detailLbl">{t("Order date")}</span>
            <span className="cc-account__detailVal"><i className="fa fa-calendar" aria-hidden="true" /> {order.date}</span>
          </div>
          <div className="cc-account__orderHeroStat">
            <span className="cc-account__detailLbl">{t("Total")}</span>
            <span className="cc-account__detailVal cc-account__orderHeroTotal">
              <MoneyDisplay lei={order.total} eurRate={order.eurRate} />
            </span>
          </div>
          <div className="cc-account__orderHeroStat">
            <span className="cc-account__detailLbl">{t("Payment method")}</span>
            <span className="cc-account__detailVal">
              {order.pickup ? "Ridicare personala / " : ""}
              {order.paymentMethod === "card" ? t("Online payment") : t("Cash on delivery")}
            </span>
          </div>
        </div>
        {(order.paymentUrl || order.returnUrl) ? (
          <div className="cc-account__actions cc-account__orderHeroActions">
            {order.paymentUrl ? (
              <Link to={order.paymentUrl} className="cc-account__actionBtn cc-account__actionBtn--pay anim">
                <i className="fa fa-credit-card" /> {t("Pay with Credit / Debit Card")}
              </Link>
            ) : null}
            {order.returnUrl ? (
              <a href={order.returnUrl} className="cc-account__actionBtn cc-account__actionBtn--return anim">
                <i className="fa fa-retweet" /> {t("Return this order")}
              </a>
            ) : null}
          </div>
        ) : null}
      </section>

      {!order.pickup ? (
        <section className="cc-account__sectionCard">
          <header className="cc-account__sectionCardHead">
            <span className="cc-account__sectionCardIcon" aria-hidden="true"><i className="fa fa-truck" /></span>
            <div>
              <h2 className="cc-account__sectionCardTitle">{t("Order information")}</h2>
              <p className="cc-account__sectionCardSub">{t("Address")}</p>
            </div>
          </header>
          <div className="cc-account__sectionCardBody">
            <div className="cc-account__detailGrid">
              <div className="cc-account__detailItem">
                <span className="cc-account__detailLbl">{t("City")}</span>
                <span className="cc-account__detailVal">{order.city}</span>
              </div>
              <div className="cc-account__detailItem">
                <span className="cc-account__detailLbl">{t("County")}</span>
                <span className="cc-account__detailVal">{order.county}</span>
              </div>
              <div className="cc-account__detailItem cc-account__detailItem--wide">
                <span className="cc-account__detailLbl">{t("Address")}</span>
                <span className="cc-account__detailVal">{order.address}{order.zip ? ` — ${order.zip}` : ""}</span>
              </div>
            </div>
          </div>
        </section>
      ) : null}

      <section className="cc-account__sectionCard">
        <header className="cc-account__sectionCardHead">
          <span className="cc-account__sectionCardIcon cc-account__sectionCardIcon--gold" aria-hidden="true"><i className="fa fa-shopping-bag" /></span>
          <div>
            <h2 className="cc-account__sectionCardTitle">{t("Products")}</h2>
            <p className="cc-account__sectionCardSub">{order.products.length}</p>
          </div>
        </header>
        <div className="cc-account__sectionCardBody cc-account__sectionCardBody--flush">
          <div className="cc-account__productList">
            {order.products.map((p) => (
              <div key={p.productId} className="cc-account__orderLine">
                <div className="cc-account__orderThumb">
                  {p.imagine ? <Link to={p.url}><img src={productImageFromUrl(p.imagine)} alt={p.nume} /></Link> : null}
                </div>
                <div className="cc-account__orderLineMain">
                  <Link to={p.url} className="cc-account__orderName anim">{p.nume}</Link>
                  <span className="cc-account__orderQty">{p.quantity} × <MoneyDisplay lei={p.price / Math.max(p.quantity, 1)} eurRate={order.eurRate} /></span>
                </div>
                <span className="cc-account__orderLineTotal">
                  <MoneyDisplay lei={p.price} eurRate={order.eurRate} />
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
